import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import _ from 'lodash';
import { ErrorHandler } from '@playbookux/playbook-web-core';
import { GET_TESTERS } from '../graphql';

import {
  Container,
  ContainerLoader,
  Loader,
  ParticipantName,
  ParticipantsList,
} from './styles';

const NEWPARTICIPANTTEXT = 'Schedule a new participant as a replacement';
const RETURNCREDITTEXT = 'Add the credits to my PlaybookUX workspace';

const ApprovalDidNotShow = ({ project }) => {
  const { id } = project;

  const {
    loading,
    data = {},
    errors,
  } = useQuery(GET_TESTERS, {
    variables: {
      approved: false,
      projectId: id,
      removed: false,
      bookingStatus: ['did_not_show'],
      offset: 0,
    },
  });

  if (loading) {
    return (
      <ContainerLoader>
        <Loader size="small" data-loader="approvals-did-not-show-loader" />
      </ContainerLoader>
    );
  }

  if (errors) {
    return (
      <ErrorHandler
        error={errors}
        defaultMessage="Error while retrieving the testers."
      />
    );
  }

  const { testers } = data;

  return (
    <Container>
      <ParticipantName>
        Participant name:
      </ParticipantName>
      <ParticipantsList>
        {_.map(testers, (value) => {
          const { firstName, lastName } = value.user.profile;
          const option = value.testSessions[0].didNotShowAction;
          return (
            <ParticipantName>
              { `${firstName} ${lastName} - ${option === 'add_credits_to_workspace' ? RETURNCREDITTEXT : NEWPARTICIPANTTEXT}`}
            </ParticipantName>
          );
        })}
      </ParticipantsList>
    </Container>
  );
};

ApprovalDidNotShow.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
};

export default ApprovalDidNotShow;
